import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon36: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 16.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 16" width={width} height={height} {...props}>
      <Path
        d="M13.314 0.0358311C13.643 -0.0951689 14 0.146828 14 0.499828V12.4998C14 12.8538 13.643 13.0958 13.314 12.9648L9 11.2378V13.9998C9 15.0548 8.18499 15.9178 7.14899 15.9948L7 15.9998C5.895 15.9998 5 15.1048 5 13.9998V9.63783L3.40399 8.99983H0.5C0.255 8.99983 0.0499956 8.82382 0.00799561 8.58982L0 8.49983V4.49983C0 4.22383 0.224 3.99983 0.5 3.99983H3.40399L13.314 0.0358311ZM6 10.0378V13.9998C6 14.5528 6.447 14.9998 7 14.9998C7.553 14.9998 8 14.5528 8 13.9998V10.8378L6 10.0378ZM13 1.23883L4 4.83783V8.16183L13 11.7618V1.23883ZM3 4.99983H1V7.99983H3V4.99983ZM15.5 7.00582H19.5C19.776 7.00582 20 6.78282 20 6.50582C20 6.22982 19.776 6.00582 19.5 6.00582H15.5C15.224 6.00582 15 6.22982 15 6.50582C15 6.78282 15.224 7.00582 15.5 7.00582ZM15.857 4.85482L18.854 1.84983C19.049 1.65383 19.049 1.33683 18.853 1.14183C18.658 0.946826 18.341 0.947833 18.146 1.14283L15.149 4.14782C14.954 4.34382 14.955 4.65982 15.15 4.85482C15.346 5.04982 15.662 5.04982 15.857 4.85482ZM15.147 8.85682L18.147 11.8498C18.342 12.0448 18.659 12.0448 18.854 11.8498C19.049 11.6538 19.049 11.3378 18.853 11.1428L15.853 8.14883C15.658 7.95383 15.341 7.95482 15.146 8.14982C14.951 8.34582 14.951 8.66182 15.147 8.85682Z"
        fill="#4775FF"
      />
    </Icon>
  )
}
